import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrap from "@fullcalendar/bootstrap";
import timeGrid from "@fullcalendar/timegrid";
import calenderList from "@fullcalendar/list";
import interaction from "@fullcalendar/interaction";
import { FaCheck, FaDotCircle } from "react-icons/fa";
import { bgcolor, style } from "@mui/system";
import { Typography } from "@mui/material";
import { Calender } from "../../components/Calender/Calender";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
const events = [
  // { title: 'Meeting', start: new Date() },
  // ,
  {
    // this object will be "parsed" into an Event Object
    title: "The Title", // a property!
    start: "2023-02-18", // a property!
    end: "2023-02-25",
    editable: true,
    durationEditable: true, // a property! ** see important note below about 'end' **
  },
];

export default () => {
  const keyss = [
    {
      img: 'require("../../assets/img/camera-icon.png")',
      value: "Install",
    },
    {
      img: 'require("../../assets/img/video-icon.png")',
      value: "Removal",
    },
  ];
  const [submitData, setSubmitData] = useState();
  const [data, setData] = useState();
  const handleChange = (key, value) => {
    setSubmitData({
      ...submitData,
      [key]: value,
    });
  };
  const currentDate = new Date();
  const options = {
    weekday: "long",
    month: "long",
    day: "numeric",
    suffix: "long",
  };
  const formattedDate = currentDate.toLocaleDateString("en-US", options);

  const displayDate = data?.date || formattedDate;
  function handleDateClick(date, events) {
    console.log({ date, events });
    setData({ date, events });
  }
  const handleEventsChange = async (events) => {
    const eventObjects = events.map((event) => ({
      color: event.color,
      date_time: event.date,
      title: event.title,
    }));
    setSubmitData({
      ...submitData,
      events: eventObjects,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitData?.campaign_type) {
      apiClient.post("/installerSchedule", submitData);
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="text-end">
          {/* <div className="dropdown">
          <button className="btn btn_bg shadow-none " type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            Vehicle
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li><a className="dropdown-item text-primary " href="#">Isuzu, N-Series</a></li>
            <li><a className="dropdown-item text-primary " href="#">  Hino 155</a></li>
            <li><a className="dropdown-item text-primary " href="#">Freightliner</a></li>
          </ul>
        </div> */}
          {/* <div className="dropdown mb-2 ">
            <button
              className="btn btn_bg shadow-none dropdown-toggle "
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Campaign
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("campaign_type", "NetFlix")}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    style={{ width: "100%" }}
                    src={require("../../assets/img/netflix-img.png")}
                    alt=""
                  />
                </div>
                <a className="dropdown-item fw-bold"style={{color:"#005E9D"}}>
                  -NetFlix
                </a>
              </li>
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("campaign_type", "Addidas")}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    style={{ width: "100%" }}
                    src={require("../../assets/img/adidas-img.png")}
                    alt=""
                  />
                </div>
                <a
                  className="dropdown-item  fw-bold"
                  style={{color:"#005E9D"}}
                >
                  {" "}
                  -Addidas
                </a>
              </li>
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("campaign_type", "Disney")}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    width={"100%"}
                    src={require("../../assets/img/disnep-img.png")}
                    alt=""
                  />
                </div>

                <a
                  className="dropdown-item fw-bold "
                  style={{color:"#005E9D"}}
                >
                  -Disney
                </a>
              </li>
            </ul>
          </div> */}
        </div>
        <Calender keyss={keyss} handleDateClick={handleDateClick} />
        <div className="row mt-2">
          <div className="col-md-8">
            <div className="me-2 border h-100 p-2 rounded-3">
              <h5 className="text_color  ">{displayDate}</h5>
              <hr className="hr_design mt-0" />
              {!(data?.events.length == 0) ? (
                <>
                  {data?.events?.map((event) => {
                    let imageSrc = "";
                    if (event.title === "PhotoShoot") {
                      imageSrc = require("../../assets/img/camera-icon.png");
                    } else if (event.title === "Videoshoot") {
                      imageSrc = require("../../assets/img/video-icon.png");
                    } else if (event.title === "DroneShoot") {
                      imageSrc = require("../../assets/img/drone-dark.png");
                    }
                    return (
                      <div className="d-flex gap-2 align-item-center flex-column flex-md-row">
                        <div style={{ width: "1rem" }}>
                          <img width="100%" src={imageSrc} alt="" />
                        </div>

                        <span>
                          - {event.title} at {event.time} <br />- Address:{" "}
                          {event.address}
                        </span>
                      </div>
                    );
                  })}
                </>
              ) : (
                "No Event"
              )}
              {/* <div className="d-flex gap-2 align-item-center flex-column flex-md-row mt-2">
              <div style={{ width: "1rem" }}>
                <img
                  width="100%"
                  src={require("../../assets/img/camera-icon.png")}
                  alt=""
                />
              </div>
              <span>
                - PhotoShoot in front of Moda Center after Swram at 5:30pm.{" "}
                <br />- Address: 321 Moda Rd., Portland, OR
              </span>
            </div> */}
            </div>
          </div>
          <div className="col-md-4">
            <div className=" border p-2 rounded-3">
              <div className="d-flex gap-3 align-item-center px-2">
                <div>
                  <h5 className="text_color">Key</h5>
                  <hr className="hr_design_2 mt-0" />
                </div>
                <div className="mt-3 ">
                  {/* <p className=" text_color text_color d-flex align-items-center gap-1">
                  <FaDotCircle color="#00D030" />
                  Campain start
                </p> */}

                  {/* <p className="text_color d-flex align-items-center gap-1">
                  <FaDotCircle color="#F20000" />
                  Campain End
                </p> */}

                  {/* <p className=" text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/schedule-job-icon.png")}
                      alt=""
                    />
                  </div>
                  Install
                </p> */}

                  {/* <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/schedule-x-icon.PNG")}
                      alt=""
                    />
                  </div>
                  Removal
                </p> */}

                  {/* <p className="text_color text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/retargeting.png")}
                      alt=""
                    />
                  </div>
                  Retargeting
                </p> */}

                  <p className="text_color text_color d-flex align-items-center gap-1">
                    <div style={{ width: "1rem" }}>
                      <img
                        width="100%"
                        src={require("../../assets/img/schedule-job-icon.png")}
                        alt=""
                      />
                    </div>
                    Install
                  </p>
                  <p className="text_color text_color d-flex align-items-center gap-1">
                    <div style={{ width: "1rem" }}>
                      <img
                        width="100%"
                        src={require("../../assets/img/schedule-x-icon.PNG")}
                        alt=""
                      />
                    </div>
                    Removal
                  </p>

                  {/* <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/bee.png")}
                      alt=""
                    />
                  </div>
                  Swarm
                </p> */}

                  {/* <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/brush.png")}
                      alt=""
                    />
                  </div>
                  Creative
                </p> */}

                  {/* <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/new-report.png")}
                      alt=""
                    />
                  </div>
                  New Report
                </p> */}
                </div>
              </div>
            </div>
            <button className="btn btn_bg mt-2">
              View Current Jobs to see individual dates & <br />
              further details.
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col text-center mt-5 save-main">
            <button type="submit" className="btn_bgnone btn blue-clr">
              <span className="pe-2">Save Changes</span>
              <FaCheck />
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
